import { useState, useEffect, useRef } from 'react';
const LazyThumbnail = ({ cameraId, alt, className, thumbnailSupported = true }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const imgRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );
    if (imgRef.current) {
      observer.observe(imgRef.current);
    }
    return () => observer.disconnect();
  }, []);
  // Retry on error (up to 3 times with increasing delay)
  useEffect(() => {
    if (hasError && retryCount < 3) {
      const timer = setTimeout(() => {
        setHasError(false);
        setIsLoaded(false);
        setRetryCount(r => r + 1);
      }, (retryCount + 1) * 5000);
      return () => clearTimeout(timer);
    }
  }, [hasError, retryCount]);
  const tenantId = localStorage.getItem("currentTenantId");
  const cacheBust = retryCount > 0 ? '&_r=' + retryCount : '';
  const src = thumbnailSupported !== false
    ? '/api/vms/cameras/' + encodeURIComponent(cameraId) + '/thumbnail?tenantId=' + tenantId + cacheBust
    : null;
  return (
    <div ref={imgRef} className={'lazy-thumbnail ' + (className || '')}>
      {!thumbnailSupported ? (
        <div className="thumbnail-error">
          <span>No preview</span>
        </div>
      ) : !isVisible ? (
        <div className="thumbnail-placeholder">
          <div className="thumbnail-spinner" />
        </div>
      ) : hasError && retryCount >= 3 ? (
        <div className="thumbnail-error">
          <span>No preview</span>
        </div>
      ) : hasError ? (
        <div className="thumbnail-placeholder">
          <div className="thumbnail-spinner" />
        </div>
      ) : (
        <>
          {!isLoaded && (
            <div className="thumbnail-placeholder">
              <div className="thumbnail-spinner" />
            </div>
          )}
          <img
            src={src}
            alt={alt}
            onLoad={() => setIsLoaded(true)}
            onError={() => setHasError(true)}
            style={{ opacity: isLoaded ? 1 : 0 }}
          />
        </>
      )}
    </div>
  );
};
export default LazyThumbnail;
